import { render, staticRenderFns } from "./FilterDoctor.vue?vue&type=template&id=14898ab8&scoped=true&lang=pug&"
import script from "./FilterDoctor.vue?vue&type=script&lang=js&"
export * from "./FilterDoctor.vue?vue&type=script&lang=js&"
import style0 from "./FilterDoctor.vue?vue&type=style&index=0&id=14898ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14898ab8",
  null
  
)

export default component.exports